import { defineMessages, FormattedMessage } from 'react-intl';
import { NotificationService, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_INFO } from 'ui-components/services/notification-service';
import * as Actions from '../store/identity-verification/identity-verification.actions';
import * as AccountActions from '../store/account-information/account-information.actions';

const messages = defineMessages({
  'idv-success-title': {
    id: 'BfSdh8',
    description: 'Title for IDV success notification',
    defaultMessage: 'Account Successfully Verified',
  },
  'idv-success-content': {
    id: 'XgPzrw',
    description: 'Content for IDV success notification',
    defaultMessage: 'Your account has been successfully verified.',
  },
  'idv-pending-title': {
    id: 'latij6',
    description: 'Title for IDV pending review notification',
    defaultMessage: 'Account Pending Review',
  },
  'idv-pending-content': {
    id: 'BdEYZS',
    description: 'Content for IDV pending review notification',
    defaultMessage: 'Your account is under manual review.',
  },
});

export class IdentityVerificationService {
  static handleIdentityVerificationSuccess() {
    const successNotification = {
      title: <FormattedMessage {...messages['idv-success-title']} />,
      content: <FormattedMessage {...messages['idv-success-content']} />,
      notificationType: NOTIFICATION_TYPE_SUCCESS,
      duration: 3000,
    };

    NotificationService.showNotification(successNotification);

    // refresh state for trust status
    return [Actions.identityVerificationSuccess(successNotification), AccountActions.getAccountInformation(false)];
  }

  static handleIdentityVerificationPending() {
    const pendingNotification = {
      title: <FormattedMessage {...messages['idv-pending-title']} />,
      content: <FormattedMessage {...messages['idv-pending-content']} />,
      notificationType: NOTIFICATION_TYPE_INFO,
      duration: 3000,
    };

    // refresh state for trust status
    AccountActions.getAccountInformation(false);

    NotificationService.showNotification(pendingNotification);
    return [Actions.identityVerificationPending(pendingNotification), AccountActions.getAccountInformation(false)];
  }
}
